import type { NodeLabel, RelationType } from '@wt-codegraph/shared';

import type { ApiClient } from './client.js';

export interface GraphNodeDto {
  readonly id: string;
  readonly kind: NodeLabel;
  readonly name: string;
  readonly qualifiedName?: string;
  readonly filePath?: string;
  readonly startLine?: number;
}

export interface GraphEdgeDto {
  readonly id: string;
  readonly source: string;
  readonly target: string;
  readonly type: RelationType;
}

export interface GraphDto {
  readonly nodes: readonly GraphNodeDto[];
  readonly edges: readonly GraphEdgeDto[];
  readonly truncated: boolean;
  readonly totalNodes: number;
  readonly totalEdges: number;
}

export async function getFullGraph(api: ApiClient, slug: string): Promise<GraphDto> {
  return api.request<GraphDto>(`/api/repos/${encodeURIComponent(slug)}/graph`);
}
